import { Anrede } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anrede';
import { Mitarbeiter_Anrede } from '@/gql/graphql';

export function mapAnrede(anrede: Anrede): Mitarbeiter_Anrede {
  switch (anrede) {
    case 'Frau':
      return Mitarbeiter_Anrede.Frau;
    case 'Herr':
      return Mitarbeiter_Anrede.Herr;
    case 'divers':
      return Mitarbeiter_Anrede.Divers;
    default:
      anrede satisfies never;
      throw new Error(`Unsupported Anrede: ${anrede}`);
  }
}
